(() => {
  'use strict';
  const root = document.querySelector('[data-county-preview]');
  if (!root) return;
  const config = JSON.parse(document.getElementById('swr-county-translations').textContent);
  const query = new URLSearchParams(location.search);
  const themeId = root.dataset.themeId || '';
  const provider = document.getElementById('swr-county-provider');
  const panels = [...root.querySelectorAll('[data-provider-panel]')];
  const systemLinks = [...root.querySelectorAll('[data-system-link]')];
  let county = root.dataset.county;
  const report = document.getElementById('swr-full-report');
  const reportButton = root.querySelector('[data-full-report-button]');
  let selectedFlow = provider.selectedOptions[0].dataset.flowProvider;

  root.querySelectorAll('a[href]').forEach(link => {
    const raw = link.getAttribute('href');
    if (!raw || raw.startsWith('#')) return;
    const url = new URL(raw, location.origin);
    if (url.origin !== location.origin) return;
    if (themeId) url.searchParams.set('preview_theme_id', themeId);
    else url.searchParams.delete('preview_theme_id');
    const zip = query.get('zip');
    if (link.hasAttribute('data-system-link') && /^\d{5}$/.test(zip || '')) url.searchParams.set('zip', zip);
    link.href = url.pathname + url.search + url.hash;
  });

  function selectProvider() {
    const current = panels.find(panel => panel.dataset.providerPanel === provider.value);
    panels.forEach(panel => { panel.hidden = panel !== current; });
    selectedFlow = current?.dataset.flowProvider || 'other';
    county = current?.dataset.reportCounty || root.dataset.county;
    systemLinks.forEach(link => {
      const url = new URL(link.href, location.origin);
      url.searchParams.set('provider', selectedFlow);
      url.searchParams.set('county', county);
      link.href = url.pathname + url.search;
    });
  }
  const requested = query.get('report_provider') || query.get('provider');
  const requestedOption = [...provider.options].find(option => option.value === requested) || (requested && requested !== 'other' ? [...provider.options].find(option => option.dataset.flowProvider === requested) : null);
  if (requestedOption) provider.value = requestedOption.value;
  provider.addEventListener('change', selectProvider);
  selectProvider();
  systemLinks.forEach(link => link.addEventListener('click', () => {
    try {
      const key = 'clearhouse-buying-v3';
      const state = JSON.parse(sessionStorage.getItem(key) || '{}');
      if (!state || typeof state !== 'object' || Array.isArray(state)) return;
      if (state.provider !== selectedFlow || state.county !== county) {
        delete state.home;
        delete state.selection;
        state.provider = selectedFlow;
        state.county = county;
        state.source = selectedFlow === 'well' ? 'well' : selectedFlow === 'other' ? 'unknown' : 'city';
        state.confirmed = !['other', 'well'].includes(selectedFlow);
        sessionStorage.setItem(key, JSON.stringify(state));
      }
    } catch (_) {}
  }));

  function syncReport() {
    reportButton.setAttribute('aria-expanded', String(!report.hidden));
    reportButton.querySelector('[data-full-label]').textContent = report.hidden ? config.showReport : config.hideReport;
    reportButton.querySelector('[data-full-icon]').textContent = report.hidden ? '+' : '−';
  }
  function showReport(scroll = true) {
    report.hidden = false;
    syncReport();
    if (scroll) report.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
  }
  reportButton.addEventListener('click', () => {
    if (report.hidden) showReport();
    else { report.hidden = true; syncReport(); }
  });
  if (location.hash === '#swr-full-report' || (location.hash && report.querySelector('[id="' + CSS.escape(location.hash.slice(1)) + '"]'))) showReport(false);
  syncReport();
  root.querySelectorAll('a[href^="#"]').forEach(link => link.addEventListener('click', () => {
    const target = document.getElementById(link.hash.slice(1));
    if (target && report.contains(target)) showReport(false);
  }));

  const search = document.getElementById('swr-county-search');
  const rows = [...report.querySelectorAll('tbody tr')];
  const groups = [...report.querySelectorAll('details.cw-group')];
  const initialOpen = new Map(groups.map(group => [group, group.open]));
  function filterRows() {
    const term = search.value.trim().toLocaleLowerCase();
    let count = 0;
    rows.forEach(row => {
      const group = row.closest('details.cw-group');
      const context = group?.querySelector('summary')?.textContent || '';
      const matches = (row.textContent + ' ' + context).toLocaleLowerCase().includes(term);
      row.hidden = !matches;
      if (matches) count++;
    });
    groups.forEach(group => {
      const groupRows = [...group.querySelectorAll('tbody tr')];
      if (!groupRows.length) return;
      const hasMatch = groupRows.some(row => !row.hidden);
      group.hidden = !hasMatch;
      group.open = term ? hasMatch : initialOpen.get(group);
    });
    root.querySelector('[data-search-status]').textContent = count ? config.count.replace('__count__',count) : term ? config.zero : '';
    root.querySelector('[data-no-results]').hidden = !term || count > 0;
  }
  search.addEventListener('input', filterRows);
  root.querySelector('[data-clear-search]').addEventListener('click', () => { search.value=''; filterRows(); search.focus(); });
  filterRows();

  const dialog = document.getElementById('swr-email-dialog');
  root.querySelector('[data-email-open]').addEventListener('click', () => dialog.showModal());
  root.querySelectorAll('[data-email-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('close', () => { document.getElementById('swr-email-address').value=''; });
  const observePreviewBar = () => {
    const bar = document.getElementById('PBarNextFrame');
    if (!bar) return false;
    const updateOffset = () => {
      const rect = bar.getBoundingClientRect();
      root.style.setProperty('--swr-preview-bar-offset',Math.min(rect.height > 0 && rect.top < innerHeight ? innerHeight-rect.top : 0,64)+'px');
    };
    new ResizeObserver(updateOffset).observe(bar);
    window.addEventListener('resize',updateOffset);
    updateOffset();return true;
  };
  if (!observePreviewBar()) {
    const observer = new MutationObserver(() => { if (observePreviewBar()) observer.disconnect(); });
    observer.observe(document.body,{childList:true});
  }
})();
